import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Row, Col, Typography } from "antd";
import Page from "../../../common/components/Page";
import Shortcut from "../../../common/components/Shortcut";
import { resetQueryList } from "../../../state/queryStore";
import getConfigs from "../../../GetConfigs";

const CivilQuery = () => {
  const dispatch = useDispatch();

  const configurations = getConfigs([
    "cvDailyQuery",
    "cvAttorneyQuery"
  ]);
  useEffect(() => {
    dispatch(resetQueryList());
  }, [dispatch]);

  return (
    <Page>
      <Page.Title icon="balance-scale" title="Civil Case Schedule Query" />
      <Typography.Title level={5}>Schedule Type</Typography.Title>
      <Page.Content>
        <Row gutter={[12, 12]}>
          {(configurations.cvDailyQuery && configurations.cvDailyQuery.toLowerCase() === "true") && 
            <Col xl={6} lg={6} md={12} sm={12} xs={24}>
              <Shortcut icon="book" name="Daily Case Schedule Query" route="/civil-query/daily-query" />
            </Col>}
          {(configurations.cvDailyQuery && configurations.cvAttorneyQuery.toLowerCase()) === "true" && <Col xl={6} lg={6} md={12} sm={12} xs={24}>
            <Shortcut icon="cubes" name="Attorney Case Schedule Query" route="/civil-query/attorney-query" />
          </Col>}
        </Row>
      </Page.Content>
    </Page>
  );
};

export default CivilQuery;
